'use client'

import "./book-detail.css"
import { BookInterface } from "../../books/types/book";
import BookContent from "../BookContent/BookContent";
import BookHeader from "../BookHeader/BookHeader";
import { Drawer } from "./Drawer";
interface BookDetailsProps {
    book: BookInterface | null;
    isOpen: boolean;
    onClose?: () => void;
}

const BookDetails = ({ book, isOpen, onClose }: BookDetailsProps) => {
    if (!book) return null;
    if (!isOpen) return null;

    return (
      <div className={`details-container ${!onClose ? 'soloBookPage' : ''}`}>
      <Drawer isOpen={isOpen} onClose={onClose}>
            <BookHeader book={book}/>
            <BookContent book={book}/>
            </Drawer>
      </div>
    );
  };
  
  export default BookDetails
